import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_LEGAL_PERSON_UPLOAD,
  STORE_LEGAL_PERSON_UPLOAD_LIST_FILES,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { ErrorStore, ListUploadFilesResponse } from '@types'
import { createGenericSlice, GenericState } from 'stores/generics/create-slice'
import { createReducers, ExtraReducers } from 'stores/generics/create-reducers'
import { Payload } from 'stores'

export type UploadListFilesState = ListUploadFilesResponse

type State = GenericState<UploadListFilesState>

export const initialState: State = {
  data: {
    files: [],
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchUploadListFiles = createAsyncThunk<
  UploadListFilesState,
  Promise<ListUploadFilesResponse>,
  Payload
>(
  STORE_LEGAL_PERSON_UPLOAD_LIST_FILES,
  async (promise, { rejectWithValue }) => {
    try {
      const response = await promise
      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  UploadListFilesState,
  ListUploadFilesResponse,
  Payload
>(fetchUploadListFiles, initialState.data)

const slice = createGenericSlice({
  name: STORE_LEGAL_PERSON_UPLOAD,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear } = actions

export { clear }

export default reducer
